import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_ORDER_NEW_RECORD, GET_ORDER_NEW_RECORD, GET_ORDER_LINEITEMS} from '../actions';

import {
    createOrderItemNewRecordSuccess,
    createOrderItemNewRecordError,
    getOrderItemNewRecordSuccess,
    getOrderItemNewRecordError,
    getRecordsSuccess,
    getRecordsError,    
} from './actions';
// eslint-disable-next-line
const getRecordListAsync = async (payload) => {
  const sendDate = new Date().getTime();
  let receiveDate = new Date().getTime();
  // eslint-disable-next-line
  const pageSize = 20;


        let recordOrderListReturned = []
        recordOrderListReturned.data = [];
        recordOrderListReturned.data.items = [];

        let item3 = [];
        item3.line_item_id = "4";
        item3.invoiceId = 4;
        item3.quantity = 1;
        item3.name = "Students in Psychology 1";
        item3.cost_per_unit = "11" ;
        item3.line_total = 11;
        recordOrderListReturned.data.items.push(item3);

        let item2= [];
        item2.line_item_id = "5";
        item3.invoiceId = 4;
        item2.quantity = 2;
        item2.name = "Membership 1";
        item2.cost_per_unit = "10" ;
        item2.line_total = 20;
        recordOrderListReturned.data.items.push(item2);

        //search by orderId
        //const recordRemittanceListReturned = await axios.get("vocabularies?trashed=false&search_text=" + remittanceSearchText + "&page_number=" + payload.pageNumber);

        return {
          recordList: recordOrderListReturned,
          total_item_count: recordOrderListReturned.data.total_item_count,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
};

function* getRecordList({ payload }) {
  try {
    const pageSize = 20;
    const recordListReturned = yield call(getRecordListAsync, payload);
    if (!recordListReturned.message) {
      const recordListParam = {
        records: recordListReturned.recordList,
        pagination: {
          pageNumber: payload.pageNumber,
          pageSize,
          startIndex: (payload.pageNumber - 1) * pageSize + 1,
          totalItemCount: recordListReturned.total_item_count,
          totalPages: Math.ceil(recordListReturned.total_item_count / pageSize),
        },
        responseTime: recordListReturned.responseTime,
      };
      if (payload.searchInputName) {
        recordListParam.searchInputName = recordListReturned.recordList;
      }
      yield put(getRecordsSuccess(recordListParam));
    } else {
      yield put(getRecordsError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getRecordsError(error));
  }
}

const CREATE_NEW_RECORD_ERROR = "New record success.";

const createOrderMethodNewRecordAsync = async (newRecord) => {

  try{
    if (newRecord.order_id > 0)
    {
      const responseObject = await centralApiAxios.put("orders?id="+ newRecord.order_id, newRecord);

      return {
      newsItem: responseObject.data,
      order_id: responseObject.data.order_id,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.order_id > 0),
      message: ""
      };
    }
    else{
      const responseObject = await centralApiAxios.post("orders?id="+ newRecord.order_id, newRecord);

      return {
      newsItem: responseObject.data,
      order_id: responseObject.data.order_id,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.order_id > 0),
      message: ""
      };
    }

  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* createOrderItemNewRecord({ payload }) {
     const { history } = payload;
    try {
      const resultReturned = yield call(createOrderMethodNewRecordAsync, payload);
      if (!resultReturned.message) {
        yield put(createOrderItemNewRecordSuccess(resultReturned));
        if (resultReturned.isNewsItemCreate)
        {
           history.push("/app/order-editor/4");
          window.location.reload();
        }
        if (payload.newRecord.catalogItemRecord.trashed == true) {
          history.push("/app/RecordListing/Vocabularies");
          window.location.reload();
        }
        else{
          window.location.reload();
        }
    } else {
        yield put(createOrderItemNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(createOrderItemNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

const getOrderItemNewRecordAsync = async (payload) => {

  if (payload.orderId == 0)
  {
    return {
      orderItemRecord: undefined,
      orderId: 0,
      message: ""
    };
  }
  try{
    const responseObject = await centralApiAxios.get(`/orders/${  payload.orderId}?lcid=1033`);
    return {
    orderItemRecord: responseObject.data,
    orderId: responseObject.data.orderId,
    message: ""
    };
  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* getOrderItemNewRecord({ payload }) {
    // const { history } = payload;
    try {
      const resultReturned = yield call(getOrderItemNewRecordAsync, payload);
      if (!resultReturned.message) {
        yield put(getOrderItemNewRecordSuccess(resultReturned));
      } else {
        yield put(getOrderItemNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(getOrderItemNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

export function* watchGetRecords() {
  yield takeEvery(GET_ORDER_LINEITEMS, getRecordList);
}
// eslint-disable-next-line
export function* watchCreateRecords(newRecord) {
  yield takeEvery(CREATE_ORDER_NEW_RECORD, createOrderItemNewRecord);
}
// eslint-disable-next-line
export function* watchGetOrderItemNewRecord(newRecord) {
  yield takeEvery(GET_ORDER_NEW_RECORD, getOrderItemNewRecord);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetOrderItemNewRecord),
        fork(watchCreateRecords),
        fork(watchGetRecords)
    ]);
}
